export enum ENotificationType {
	READ = "read",
	ACTION = "action",
}
